import { render } from "./TickerDetailModal.vue?vue&type=template&id=2fee0dd0&scoped=true"
import script from "./TickerDetailModal.vue?vue&type=script&lang=js"
export * from "./TickerDetailModal.vue?vue&type=script&lang=js"

import "./TickerDetailModal.vue?vue&type=style&index=0&id=2fee0dd0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2fee0dd0"]])

export default __exports__